import FactCheckIcon from "@mui/icons-material/FactCheck";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import { type SvgIconOwnProps } from "@mui/material";
import { type FC } from "react";

import { AlertStatusEnum } from "~/feature/event/components/AlertSection/types";

export const alertTitle: Record<AlertStatusEnum, string> = {
  [AlertStatusEnum.UnifiedResolution]:
    "Unified Resolution Criteria (Consistent across platforms)",
  [AlertStatusEnum.Divergence]: "Divergence Detected",
};

export const alertIcon: Record<AlertStatusEnum, FC<SvgIconOwnProps>> = {
  [AlertStatusEnum.UnifiedResolution]: FactCheckIcon,
  [AlertStatusEnum.Divergence]: GppMaybeIcon,
};
